import React from "react";
import { computeCompleteness, completenessColor } from "./completeness";

/**
 * Small SVG ring showing how complete a song is (title, composer, audio, PDF, BPM, key).
 *
 * Props:
 *  - song : the song object
 *  - size : pixel size (default 22)
 *  - showLabel : if true, displays "5/6" next to the ring (default false)
 */
export const CompletenessRing = ({ song, size = 22, showLabel = false, className = "" }) => {
  const { done, total, pct } = computeCompleteness(song);
  const color = completenessColor({ done, total });
  const r = (size - 4) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct);

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      title={`${done}/${total} champs renseignés`}
      data-testid="completeness-ring"
      data-done={done}
      data-total={total}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(255,255,255,0.12)"
          strokeWidth={2.5}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.35s ease" }}
        />
      </svg>
      {showLabel && (
        <span
          className="text-[10px] font-bold tabular-nums"
          style={{ color }}
        >
          {done}/{total}
        </span>
      )}
    </span>
  );
};

export default CompletenessRing;
